export const capitalizeFirstLetter = (input?: string): string => {
  return input ? input.charAt(0).toUpperCase() + input.slice(1) : '';
};
